import { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import request from "../../../utilities/requests";
import { toast } from "../../../utilities/SnackBarUtils";

const BillingNotifications = ({ invoiceId }) => {
  const [notifications, setNotifications] = useState([]);
  const [open, setOpen] = useState(false);
  const [reminder, setReminder] = useState("");

  useEffect(() => {
    getNotifications();
  }, []);

  const getNotifications = async () => {
    const result = await request(
      `contracts/invoice/notifications/?invoiceId=${invoiceId}`
    );
    if (result.success) {
      setNotifications(result.notifications);
    }
  };

  const handleSend = async () => {
    if (!reminder) {
        toast.error("Please select a reminder type");
        return
    }
    const body = {
        invoiceId, notificationType: reminder
    }
    const result = await request('contracts/invoice/sendreminder', 'post', body);
    if (result.success) {
        toast.success("Reminder sent!");
        handleClose();
    }
  }

  const handleClose = () => {
    setOpen(false);
    setReminder("");
  };

  return (
    <Grid item xs={12} sx={{ mt: 2 }}>
      <Grid container directioin="row">
        <Grid item xs={6}>
          <Typography variant="subtitle2" style={{ marginBottom: 10 }}>
            Billing Notifications
          </Typography>
          {notifications.map((note, idx) => (
            <div key={idx} style={{ marginBottom: "8px" }}>
              <Typography variant="body2">{note.subtype}</Typography>
              <Typography variant="caption" color="textSecondary">
                {note.sentAt ? new Date(note.sentAt).toLocaleString() : ""}{" "}
              </Typography>
            </div>
          ))}
        </Grid>
        <Grid item xs={6}>
          <Button
            size="small"
            variant="contained"
            onClick={() => setOpen(true)}
          >
            Send Reminder
          </Button>
        </Grid>
      </Grid>
      <Dialog open={open} onClose={handleClose}>
        <DialogTitle>Send Billing Reminder</DialogTitle>
        <DialogContent style={{padding: 10}}>
          <FormControl fullWidth>
            <InputLabel>Reminder Type</InputLabel>
            <Select
              value={reminder}
              onChange={(e) => setReminder(e.target.value)}
              fullWidth
              label="Reminder Type"
            >
              <MenuItem value="paymentDue">Payment Due</MenuItem>
              <MenuItem value="firstReminder">First Reminder</MenuItem>
              <MenuItem value="secondReminder">Second Reminder</MenuItem>
              <MenuItem value="finalReminder">Final Reminder</MenuItem>
            </Select>
          </FormControl>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSend}>Send</Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
};

export default BillingNotifications;
